
/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import * as Chart from 'chart.js';

const ReusableBarChart = ({ 
  data, 
  title = '', 
  width = 400, 
  height = 300,
  colors = ['#a8d5a8', '#ffb380'],
  showLegend = true,
  showDataLabels = true 
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext('2d');
    
    Chart.Chart.register(
      Chart.CategoryScale,
      Chart.LinearScale,
      Chart.BarElement,
      Chart.Title,
      Chart.Tooltip,
      Chart.Legend
    );

    const chartData = {
      labels: data.labels,
      datasets: data.datasets.map((dataset, index) => ({
        label: dataset.label,
        data: dataset.data,
        backgroundColor: colors[index % colors.length],
        borderColor: colors[index % colors.length],
        borderWidth: 1,
        barThickness: 40,
      }))
    };

    const config = {
      type: 'bar',
      data: chartData,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: !!title,
            text: title,
            font: {
              size: 16,
              weight: 'bold'
            }
          },
          legend: {
            display: showLegend,
            position: 'bottom',
            labels: {
              usePointStyle: true,
              pointStyle: 'rect',
              padding: 20
            }
          },
          tooltip: {
            mode: 'index',
            intersect: false,
          }
        },
        scales: {
          x: {
            display: true,
            title: {
              display: false
            },
            grid: {
              display: false
            }
          },
          y: {
            display: true,
            beginAtZero: true,
            title: {
              display: false
            },
            grid: {
              display: true,
              color: '#e5e5e5'
            },
            ticks: {
              stepSize: 10
            }
          }
        },
        layout: {
          padding: {
            top: 20,
            bottom: 20,
            left: 20,
            right: 20
          }
        }
      }
    };

    // Add data labels plugin if enabled
    // if (showDataLabels) {
    //   config.plugins = [{
    //     id: 'dataLabels',
    //     afterDatasetsDraw: (chart) => {
    //       const ctx = chart.ctx;
    //       chart.data.datasets.forEach((dataset, datasetIndex) => {
    //         const meta = chart.getDatasetMeta(datasetIndex);
    //         meta.data.forEach((bar, index) => {
    //           const data = dataset.data[index];
    //           ctx.fillStyle = '#333';
    //           ctx.font = 'bold 12px Arial';
    //           ctx.textAlign = 'center';
    //           ctx.textBaseline = 'bottom';
    //           ctx.fillText(data, bar.x, bar.y - 5);
    //         });
    //       });
    //     }
    //   }];
    // }

    chartInstance.current = new Chart.Chart(ctx, config);

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, title, colors, showLegend, showDataLabels]);

  return (
    <div style={{ width, height, position: 'relative' }}>
      <canvas ref={chartRef} />
    </div>
  );
};

export default ReusableBarChart;